import isEmpty from 'lodash/isEmpty'
import type { PivotCellTextRenderer } from '../constants/types'
import type { PivotMember, PivotResult, PivotRowItem } from './types'
import { PIVOT_TOTAL_SUFFIX } from './constants'
import { PivotRowKindEnum } from './PivotRowKindEnum'

/** Key of the pivot node a flattened row aggregates under — the grand-total root for a row with no path. */
export const toPivotRowKey = (result: PivotResult, item: PivotRowItem): string =>
  !isEmpty(item.path) ? item.path[item.path.length - 1].key : result.rowRoot.key

/** Text of one member as the grid shows it under `field` — the screen's `renderCellText` result, else the member's label; a blank member keeps its label. */
export const toPivotMemberText = (
  field: string,
  { label, isBlank }: PivotMember,
  renderCellText?: PivotCellTextRenderer
): string => (isBlank ? label : (renderCellText?.({ field, label }) ?? label))

/** Text of one row-label cell as the grid shows it — blank above the row's first change and past a collapsed group's node. `renderCellText` is the screen's plain-text twin of its `renderCell`; a member it declines shows its label. */
export const toPivotRowLabelText = (
  result: PivotResult,
  item: PivotRowItem,
  level: number,
  renderCellText?: PivotCellTextRenderer
): string => {
  const node = item.path[level]
  if (!node || level < item.labelFromLevel) return ''
  const text = toPivotMemberText(result.rowFields[level].field, node.member, renderCellText)
  return item.kind === PivotRowKindEnum.Subtotal && level === item.path.length - 1
    ? `${text} ${PIVOT_TOTAL_SUFFIX}`
    : text
}
